(function () {
	const initProductAccordion = () => {
		$(".about__accordion-toggle").click(function () {
			if (!$(this).hasClass("active")) {
				$(this).addClass("active");
				$(this)
					.siblings(".about__accordion-description")
					.eq($(this).index())
					.stop()
					.slideDown(300);
			} else {
				$(this).removeClass("active");
				$(this).siblings(".about__accordion-description").stop().slideUp(300);
			}
		});
	};

const initZoomImage = () => {
    const imagesWrapper = document.querySelector(".product-media-modal__content");
    if (!imagesWrapper) return;
    const images = imagesWrapper.querySelectorAll(".js-image-zoom");

    images.forEach((el) => {
		const scaleValue = window.innerWidth >= 990 ? 0.7 : 0.5;
        let startX, startY, translateX = 0, translateY = 0, lastX = 0, lastY = 0;

        // Click/tap per zoom toggle
        el.addEventListener("click", (e) => {
            const isZoomed = el.classList.contains("zoomed");
            // Rimuovi zoom da tutte le immagini
            images.forEach(img => {
                img.classList.remove("zoomed");
                img.style.transform = "";
            });
            // Reset variabili pan
            translateX = 0; translateY = 0; lastX = 0; lastY = 0;
            // Applica zoom solo a quella cliccata
            if (!isZoomed) el.classList.add("zoomed");
        });

        // Pan touch su mobile
        el.addEventListener("touchstart", (e) => {
            if (!el.classList.contains("zoomed")) return;
            startX = e.touches[0].clientX - lastX;
            startY = e.touches[0].clientY - lastY;
        }, { passive: true });

        el.addEventListener("touchmove", (e) => {
            if (!el.classList.contains("zoomed")) return;
            e.preventDefault();
            translateX = e.touches[0].clientX - startX;
            translateY = e.touches[0].clientY - startY;
            el.style.transform = `scale(${scaleValue}) translate(${translateX / scaleValue}px, ${translateY / scaleValue}px)`;
        }, { passive: false });

        el.addEventListener("touchend", () => {
            if (!el.classList.contains("zoomed")) return;
            lastX = translateX;
            lastY = translateY;
        });
		// Pan mouse su desktop
let isMouseDown = false;
let mouseStartX, mouseStartY;

el.addEventListener("mousedown", (e) => {
    if (!el.classList.contains("zoomed")) return;
    isMouseDown = true;
    mouseStartX = e.clientX - lastX;
    mouseStartY = e.clientY - lastY;
    
    e.preventDefault();
});

el.addEventListener("mousemove", (e) => {
    if (!el.classList.contains("zoomed") || !isMouseDown) return;
    translateX = e.clientX - mouseStartX;
    translateY = e.clientY - mouseStartY;
    el.style.transform = `scale(${scaleValue}) translate(${translateX / scaleValue}px, ${translateY / scaleValue}px)`;
});

el.addEventListener("mouseup", () => {
    if (!el.classList.contains("zoomed")) return;
    isMouseDown = false;
    lastX = translateX;
    lastY = translateY;
    
});

el.addEventListener("mouseleave", () => {
    if (!el.classList.contains("zoomed")) return;
    isMouseDown = false;
    lastX = translateX;
    lastY = translateY;
});

    });
};

const initSliderZoom = () => {
    const modal = document.getElementById("zoom-modal");
    if (!modal) return;

    const modalImg = modal.querySelector(".js-zoom-modal-img");
    const closeBtn = document.getElementById("zoom-modal-close");
    const scaleValue = window.innerWidth >= 990 ? 0.7 : 0.5;

    let translateX = 0, translateY = 0, lastX = 0, lastY = 0;
    let isMouseDown = false, mouseStartX, mouseStartY;

   // Apri modal al click sulle immagini dello slider
document.querySelectorAll(".product__media-toggle").forEach((btn) => {
    btn.style.cursor = "zoom-in";
    btn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        const img = btn.closest(".product__media-item")?.querySelector(".img-responsive");
        if (!img) return;
        const fullSrc = img.src;
        modalImg.src = fullSrc;
        modalImg.alt = img.alt;
        translateX = 0; translateY = 0; lastX = 0; lastY = 0;
        modalImg.style.transform = `scale(${scaleValue}) translate(0px, 0px)`;
        modal.classList.add("active");
        document.body.style.overflow = "hidden";
    }, true); // ← true = fase capture
});


    // Chiudi modal
    const closeModal = () => {
        modal.classList.remove("active");
        document.body.style.overflow = "";
        translateX = 0; translateY = 0; lastX = 0; lastY = 0;
        modalImg.style.transform = "";
    };

    closeBtn.addEventListener("click", closeModal);
    modal.addEventListener("click", (e) => {
        if (e.target === modal) closeModal();
    });
    document.addEventListener("keydown", (e) => {
        if (e.key === "Escape") closeModal();
    });

    // Pan touch mobile
    modalImg.addEventListener("touchstart", (e) => {
        const t = e.touches[0];
        mouseStartX = t.clientX - lastX;
        mouseStartY = t.clientY - lastY;
    }, { passive: true });

    modalImg.addEventListener("touchmove", (e) => {
        e.preventDefault();
        translateX = e.touches[0].clientX - mouseStartX;
        translateY = e.touches[0].clientY - mouseStartY;
        modalImg.style.transform = `scale(${scaleValue}) translate(${translateX / scaleValue}px, ${translateY / scaleValue}px)`;
    }, { passive: false });

    modalImg.addEventListener("touchend", () => {
        lastX = translateX;
        lastY = translateY;
    });

    // Pan mouse desktop
    modalImg.addEventListener("mousedown", (e) => {
        isMouseDown = true;
        mouseStartX = e.clientX - lastX;
        mouseStartY = e.clientY - lastY;
        modalImg.classList.add("grabbing");
        e.preventDefault();
    });

    document.addEventListener("mousemove", (e) => {
        if (!isMouseDown) return;
        translateX = e.clientX - mouseStartX;
        translateY = e.clientY - mouseStartY;
        modalImg.style.transform = `scale(${scaleValue}) translate(${translateX / scaleValue}px, ${translateY / scaleValue}px)`;
    });

    document.addEventListener("mouseup", () => {
        if (!isMouseDown) return;
        isMouseDown = false;
        lastX = translateX;
        lastY = translateY;
        modalImg.classList.remove("grabbing");
    });
};



	const initRevealPopup = () => {
		const stickyBar = document.querySelector('.product__popup'); // Sticky bar
		const secondSection = document.querySelector('.product-section + section'); // Second section
		const footer = document.querySelector('footer'); // Footer

		// Check if the required elements exist - if not, skip this functionality
		if (!stickyBar || !secondSection || !footer) {
				return;
		}

		const getOffset = (element) => {
			const rect = element.getBoundingClientRect();
			return rect.top + window.scrollY;
		};

		const secondSectionMid = getOffset(secondSection);
		const footerTop = getOffset(footer);

		const handleScroll = () => {
			const scrollPosition = window.scrollY + window.innerHeight;
			const activeOffset = window.scrollY > secondSectionMid && scrollPosition < footerTop;

			stickyBar.classList[activeOffset ? "add" : "remove"]('active');
		};

		// Set up scroll listener only if elements exist
		document.addEventListener('scroll', handleScroll);

		// Initial check in case the user starts in the middle of the page
		handleScroll();
	};

	// iOS Safari blocca lo scroll verticale della pagina quando si tocca la gallery orizzontale
	// (overflow-x: scroll con snap). Questo handler rileva i gesti verticali sulla gallery
	// e li passa manualmente alla pagina, così l'utente può scorrere verso il basso normalmente.
	// MODIFICATO PER LO ZOOM SULLA FOTO
const initGalleryVerticalScroll = () => {
    if (window.innerWidth > 749) return;

    const gallery = document.querySelector(
        '.product__outer--static-column-aside .product__media-list[data-direction="horizontal"]'
    );

    if (!gallery || gallery.dataset.pinchReady === "true") return;
    gallery.dataset.pinchReady = "true";

    let startX = 0;
    let startY = 0;
    let lastY = 0;
    let pinching = false;
    let initialDistance = 1;
    let photo = null;
    let frame = null;
    let saved = null;
    let blockClickUntil = 0;

    const distance = (touches) => Math.hypot(
        touches[0].clientX - touches[1].clientX,
        touches[0].clientY - touches[1].clientY
    );

    const resetPhoto = () => {
        if (photo && frame && saved) {
            photo.style.transform = saved.transform;
            photo.style.transformOrigin = saved.origin;
            photo.style.transition = saved.transition;
            frame.style.overflow = saved.overflow;
        }

        photo = null;
        frame = null;
        saved = null;
    };

    gallery.addEventListener("touchstart", (e) => {
        if (e.touches.length === 1 && !pinching) {
            startX = e.touches[0].clientX;
            startY = lastY = e.touches[0].clientY;
            return;
        }

        if (e.touches.length !== 2 || pinching) return;

        const opener = e.target.closest(
            ".product__modal-opener--image"
        );

        frame = opener?.querySelector(".product__media");
        photo = frame?.querySelector("img");

        if (!photo) {
            frame = null;
            return;
        }

        saved = {
            transform: photo.style.transform,
            origin: photo.style.transformOrigin,
            transition: photo.style.transition,
            overflow: frame.style.overflow
        };

        const rect = photo.getBoundingClientRect();
        const centerX = (
            e.touches[0].clientX + e.touches[1].clientX
        ) / 2;
        const centerY = (
            e.touches[0].clientY + e.touches[1].clientY
        ) / 2;

        photo.style.transformOrigin =
            `${centerX - rect.left}px ${centerY - rect.top}px`;
        photo.style.transition = "none";
        frame.style.overflow = "hidden";

        initialDistance = Math.max(distance(e.touches), 1);
        pinching = true;
        blockClickUntil = Date.now() + 800;

        if (e.cancelable) e.preventDefault();
        e.stopImmediatePropagation();
    }, { capture: true, passive: false });

    gallery.addEventListener("touchmove", (e) => {
        if (pinching) {
            if (e.cancelable) e.preventDefault();
            e.stopImmediatePropagation();
            blockClickUntil = Date.now() + 800;

            if (e.touches.length === 2 && photo) {
                const scale = Math.min(
                    3,
                    Math.max(1, distance(e.touches) / initialDistance)
                );
                photo.style.transform = `scale(${scale})`;
            }

            return;
        }

        // Mantiene la gestione dello scroll pagina con un dito.
        if (e.touches.length !== 1) return;

        const deltaX = Math.abs(e.touches[0].clientX - startX);
        const deltaY = e.touches[0].clientY - lastY;
        const totalDeltaY = Math.abs(
            e.touches[0].clientY - startY
        );

        if (totalDeltaY > deltaX) {
            if (e.cancelable) e.preventDefault();
            window.scrollBy(0, -deltaY);
        }

        lastY = e.touches[0].clientY;
    }, { capture: true, passive: false });

    const endGesture = (e) => {
        if (!pinching) return;

        blockClickUntil = Date.now() + 800;
        e.stopImmediatePropagation();

        if (e.touches.length < 2) resetPhoto();

        if (e.touches.length === 0 || e.type === "touchcancel") {
            resetPhoto();
            pinching = false;
        }
    };

    gallery.addEventListener("touchend", endGesture, true);
    gallery.addEventListener("touchcancel", endGesture, true);

    // Impedisce al rilascio del pinch di aprire il fullscreen.
    gallery.addEventListener("click", (e) => {
        if (!pinching && Date.now() >= blockClickUntil) return;

        e.preventDefault();
        e.stopImmediatePropagation();
    }, true);
};

	const initBuyButtonsScroll = () => {
		const buyButtons = document.querySelector('.product__buy_buttons');
		const productRecommendations = document.querySelector('product-recommendations');

		// Check if the required elements exist - if not, skip this functionality
		if (!buyButtons || !productRecommendations) {
			return;
		}

		const handleScrollBuyButtons = () => {
			const rect = productRecommendations.getBoundingClientRect();
			const isVisible = rect.top < window.innerHeight && rect.bottom > 0;

			if (isVisible) {
				buyButtons.classList.add('hide-sticky-buttons');
			} else {
				buyButtons.classList.remove('hide-sticky-buttons');
			}
		};

		// Set up scroll listener
		document.addEventListener('scroll', handleScrollBuyButtons);

		// Initial check in case the user starts in the middle of the page
		handleScrollBuyButtons();
	};


	document.addEventListener("shopify:section:load", function () {
		initProductAccordion();
		initZoomImage();
		initSliderZoom();
		initRevealPopup();
		initBuyButtonsScroll();
		initGalleryVerticalScroll();
		if (typeof sliderInit === 'function') sliderInit();
		if (typeof subSliderInit === 'function') subSliderInit();
		if (typeof popupSliderInit === 'function') popupSliderInit();
	});

	initProductAccordion();
	initZoomImage();
	initSliderZoom();
	initRevealPopup();
	initBuyButtonsScroll();
	initGalleryVerticalScroll();
	if (typeof sliderInit === 'function') sliderInit();
	if (typeof subSliderInit === 'function') subSliderInit();
	if (typeof popupSliderInit === 'function') popupSliderInit();
})();

class FloatedForm extends HTMLElement {
	constructor() {
		super();
		this.renderForm();
	}

	renderForm() {
		fetch(this.getAttribute("data-product-url"))
			.then((response) => response.text())
			.then((responseText) => {
				const responseHTML = new DOMParser().parseFromString(
					responseText,
					"text/html"
				);
				this.productElement = responseHTML.querySelector(
					'div[id^="ProductInfo-"]'
				);

				this.preventDuplicatedIDs();
				this.removeDOMElements();
				this.setInnerHTML(this, this.productElement.innerHTML);

				if (window.Shopify && Shopify.PaymentButton) {
					Shopify.PaymentButton.init();
				}

				if (window.ProductModel) window.ProductModel.loadShopifyXR();

				this.showMoreFields();
			})
			.finally(() => {
				const selectDropDown = () => {
					$(".product__popup .product-form__controls--dropdown").each(function () {
						const elListItem = $(this).find(".dropdown-select ul li");
						const elItem = $(this).find(".dropdown-select ul");
						const selectedText = $(this).find(
							".dropdown-select .select-label"
						);

						selectedText.on("click", function (e) {
							elItem.toggleClass("active");
							if (elItem.hasClass("active")) {
								e.stopPropagation();
								$(document).click(function () {
									elItem.removeClass("active");
								});
							}
						});

						elListItem.on("click", function () {
							selectedText
								.find("span")
								.text($(this).text())
								.attr("title", $(this).text());
							elItem.removeClass("active");
							document.activeElement.blur();
						});
					});
				};

				selectDropDown();
			});
	}

	setInnerHTML(element, html) {
		element.innerHTML = html;

		// Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
		element.querySelectorAll("script").forEach((oldScriptTag) => {
			const newScriptTag = document.createElement("script");
			Array.from(oldScriptTag.attributes).forEach((attribute) => {
				newScriptTag.setAttribute(attribute.name, attribute.value);
			});
			newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
			oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
		});
	}

	preventDuplicatedIDs() {
		const sectionId = this.productElement.dataset.section;
		this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(
			sectionId,
			`floated-${sectionId}`
		);

		if (this.productElement.querySelectorAll("variant-selects")) {
			this.productElement
				.querySelectorAll("variant-selects")
				.forEach((radio) => {
					radio.dataset.originalSection = sectionId;
				});
		}

		if (this.productElement.querySelectorAll("variant-radios")) {
			this.productElement
				.querySelectorAll("variant-radios")
				.forEach((radio) => {
					radio.dataset.originalSection = sectionId;
				});
		}
	}

	removeDOMElements() {
		const text = this.productElement.querySelector(".product__text");
		if (text) text.remove();

		const tags = this.productElement.querySelector(".product__tags");
		if (tags) tags.remove();

    const title = this.productElement.querySelector(".product__title__wrapper");
		if (title) title.remove();

		const badges = this.productElement.querySelector(".product__custom-badges");
		if (badges) badges.remove();

    const price = this.productElement.querySelector(".price-wrapper");
		if (price) price.remove();

		const description = this.productElement.querySelector(
			".product__description"
		);
		if (description) description.remove();

		const sku = this.productElement.querySelector(".product__sku");
		if (sku) sku.remove();

		const inventory = this.productElement.querySelector(".product__inventory");
		if (inventory) inventory.remove();

		const pickupAvailability = this.productElement.querySelector(
			"pickup-availability"
		);
		if (pickupAvailability) pickupAvailability.remove();

		const customLiquid = this.productElement.querySelector(".custom-liquid");
		if (customLiquid) customLiquid.remove();

		const complementary = this.productElement.querySelector(
			"product-recommendations"
		);
		if (complementary) complementary.remove();

		const shareButtons = this.productElement.querySelector(".share-buttons");
		if (shareButtons) shareButtons.remove();

		const productModal = this.productElement.querySelectorAll(".product-popup");
		productModal.forEach((advantage) => {
			advantage.remove();
		});

		const productForm = this.productElement.querySelector("floated-form");
		if (productForm) productForm.remove();
	}

	showMoreFields() {
		$(".js-show-more").click(function (e) {
			e.preventDefault();
			$(this).siblings("input").removeClass("hidden");
			$(this).siblings("label").removeClass("hidden");
			$(this).remove();
		});
	}
}

customElements.define("floated-form", FloatedForm);
